module.exports = __webpack_public_path__ + "static/img/3.2b4db45e.jpg";